import { Sparkles } from "lucide-react";

export function BackgroundAnimation() {
  return (
    <>
      {/* Background Animation */}
      <div className="absolute inset-0 opacity-30">
        <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-primary rounded-full mix-blend-multiply filter blur-xl animate-pulse"></div>
        <div className="absolute top-3/4 right-1/4 w-96 h-96 bg-primary-light rounded-full mix-blend-multiply filter blur-xl animate-pulse delay-1000"></div>
        <div className="absolute bottom-1/4 left-1/2 w-96 h-96 bg-primary-dark rounded-full mix-blend-multiply filter blur-xl animate-pulse delay-500"></div>
      </div>

      {/* Floating Elements */}
      <div className="absolute inset-0 pointer-events-none">
        <Sparkles className="absolute top-20 left-20 text-white/20 w-8 h-8 animate-bounce" />
        <Sparkles className="absolute bottom-32 left-32 text-white/20 w-6 h-6 animate-bounce delay-300" />
        <Sparkles className="absolute bottom-20 right-20 text-white/20 w-8 h-8 animate-pulse delay-700" />
      </div>
    </>
  );
}
